import React from "react"
import { IPunchSetRecordDto, IQuestionDocument } from "../../../models"
import QuestionAnswerIcon from "material-ui/svg-icons/action/question-answer"
import { red500, green500 } from "material-ui/styles/colors"
import PunchSetQuestionAnswerNavigationDialog from "./PunchSetQuestionAnswerNavigationDialog"
interface IProps {
    questionDocs: IQuestionDocument[]
    punchSetRecord: IPunchSetRecordDto
}
interface IState {
    openQuestionAnswerNavigationDialog: boolean
}

export default class PunchSetQuestionAnswerIcon extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openQuestionAnswerNavigationDialog: false
        }
    }

    render() {
        const btn1Ids = (this.props.punchSetRecord.PunchIn.Btn1Ids || []).concat(this.props.punchSetRecord.PunchOut && this.props.punchSetRecord.PunchOut.Btn1Ids || [])
        const btn2Ids = (this.props.punchSetRecord.PunchIn.Btn2Ids || []).concat(this.props.punchSetRecord.PunchOut && this.props.punchSetRecord.PunchOut.Btn2Ids || [])
        if (btn1Ids.length + btn2Ids.length === 0)
            return null

        const questionDoc = this.props.questionDocs.find(i => i.Questions.find(e => btn1Ids.includes(e.GUId) || btn2Ids.includes(e.GUId)))
        const questions = questionDoc ? questionDoc.Questions : []

        if (questions.length === 0)
            return null

        const exceptionBtn1Answer = btn1Ids.find(i => {
            const question = questions.find(e => e.GUId === i)
            const answerAction = question ? question.Btn1Action : -3
            return [-2, -1].includes(answerAction) || (answerAction >= 0 && question.CreateBtn1Exception)
        })
        const exceptionBtn2Answer = btn2Ids.find(i => {
            const question = questions.find(e => e.GUId === i)
            const answerAction = question ? question.Btn2Action : -3
            return [-2, -1].includes(answerAction) || (answerAction >= 0 && question.CreateBtn2Exception)
        })
        return (
            <div>
                <QuestionAnswerIcon
                    style={{ color: (exceptionBtn1Answer || exceptionBtn2Answer) ? red500 : green500, cursor: "pointer", marginTop: 2 }}
                    onClick={() => this.setState({ openQuestionAnswerNavigationDialog: true })}
                />
                {this.state.openQuestionAnswerNavigationDialog &&
                    <PunchSetQuestionAnswerNavigationDialog
                        punchSetRecord={this.props.punchSetRecord}
                        questions={questions}
                        handleClose={() => this.setState({ openQuestionAnswerNavigationDialog: false })}
                    />
                }
            </div>
        )
    }
}